import { conditionReportPermissions } from "./ConditionReportPermissions";
import { accessPermissions } from "./accessPermissions";
import { activityPermissions } from "./activityPermissions";
import { carrierPermissions } from "./carrierPermissions";
import { configPermissions } from "./configPermissions";
import { dashboardPermissions } from "./dashboardPermissions";
import { flagsPermissions } from "./flagsPermissions";
import { formPermissions } from "./formPermissions";
import { inspectionsPermissions } from "./inspectionsPermissions";
import { inventoryPermissions } from "./inventoryPermissions";
import { invoicePermissions } from "./invoicePermissions";
import { issueTrackerPermissions } from "./issueTrackerPermissions";
import { loadPermissions } from "./loadPermissions";
import { lotPermissions } from "./lotPermissions";
import { notePermissions } from "./notePermissions";
import { pricingPermissions } from "./pricingPermissions";
import { reportsPermissions } from "./reportsPermissions";
import { reservationPermissions } from "./reservationPermissions";
import { storageInvoicePermissions } from "./storageInvoicePermissions";
import { taxRatePermissions } from "./taxRatePermissions";
import { userManagementPermissions } from "./userManagementPermissions";
import { userPermissions } from "./userPermissions";
import { vehiclePermissions } from './vehiclePermissions';
import { vendorPermissions } from './vendorPermissions';
import { remarketingPermissions } from './remarketingPermissions';

export const permissions = {
    VEHICLE: vehiclePermissions,
    LOTS: lotPermissions,
    LOADS: loadPermissions,
    Condition_Report: conditionReportPermissions,
    ACTIVITIES: activityPermissions,
    PRICING: pricingPermissions,
    USER: userPermissions,
    USER_MANAGEMENT: userManagementPermissions,
    FORMS: formPermissions,
    ACCESS: accessPermissions,
    NOTES: notePermissions,
    ISSUE_TRACKER: issueTrackerPermissions,
    DASHBOARD: dashboardPermissions,
    STORAGE_INVOICES: storageInvoicePermissions,
    INSPECTION: inspectionsPermissions,
    REPORTS: reportsPermissions,
    INVENTORY: inventoryPermissions,
    CLIENT_CONFIG: configPermissions,
    TAX_RATE: taxRatePermissions,
    INVOICES: invoicePermissions,
    RESERVATIONS: reservationPermissions,
    CARRIERS: carrierPermissions,
    FLAGS: flagsPermissions,
    VENDORS: vendorPermissions,
    REMARKETING: remarketingPermissions,
}